import styled, { keyframes } from 'styled-components';
import Typography from '../../styles/Typography';
import { SpinnerMode, SpinnerSize } from './enums';
import { SpinnerProps } from './types';
import { WHITE } from '../../../theme/brandColors';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SIZE: Record<SpinnerSize, string> = {
  [SpinnerSize.ExtraSmall]: '0.12rem',
  [SpinnerSize.Small]: '0.25rem',
  [SpinnerSize.Big]: '0.5rem',
};

const TRACK_COLOR: Record<SpinnerMode, string> = {
  [SpinnerMode.Light]: 'rgba(255,255,255,0.2)',
  [SpinnerMode.Dark]: 'rgba(118,177,89,0.2)',
};

const FILL_COLOR: Record<SpinnerMode, string> = {
  [SpinnerMode.Light]: WHITE,
  [SpinnerMode.Dark]: 'var(--brand-green)',
};

export const StyledSpinner = styled.div<SpinnerProps>`
  border-radius: 50%;
  width: 10em;
  height: 10em;
  overflow: hidden;
  font-size: ${({ size = SpinnerSize.Small }) => SIZE[size]};
  position: relative;
  text-indent: -9999em;
  border-top: 1.5em solid
    ${({ mode = SpinnerMode.Light }) => TRACK_COLOR[mode]};
  border-right: 1.5em solid
    ${({ mode = SpinnerMode.Light }) => TRACK_COLOR[mode]};
  border-bottom: 1.5em solid
    ${({ mode = SpinnerMode.Light }) => TRACK_COLOR[mode]};
  border-left: 1.5em solid
    ${({ mode = SpinnerMode.Light }) => FILL_COLOR[mode]};
  transform: translateZ(0);
  animation: ${rotate} 1.1s infinite linear;
`;

export const StyledSpinnerOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  z-index: ${({ theme }) => theme.zindexes.loaderOverlay};
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledSpinnerDescription = styled(Typography).attrs({
  variant: 'body',
})`
  color: var(--surface);
  text-align: center;
  margin-top: 1rem;
  max-width: 20rem;
  width: 100%;
`;
